import { atom } from 'jotai';

interface ReferralGiftsData {
  inviteCode?: string;
  fromUid?: string;
  avatarUrl?: string;
  userName?: string;
  giftType?: string;
  showTimeRange?: string;
  activityStatus?: number;
  amountStr?: string;
}

export const $ReferralGiftsStore = atom<ReferralGiftsData>({
  inviteCode: '******',
  activityStatus: 4,
  giftType: '1',
  amountStr: '$10',
  showTimeRange: '',
});

export const $ReferralGiftsData = atom(
  (get) => {
    return get($ReferralGiftsStore);
  },
  (get, set, args: Record<keyof ReferralGiftsData, any>) => {
    const old = get($ReferralGiftsStore);
    set($ReferralGiftsStore, { ...old, ...args });
  },
);
